import { Sidenav } from 'mdb-ui-kit';

var sidenavInstance = null;
var innerWidth = 0;
var isSlim: boolean = false;

function initSideNav() {
    const sidenavEl: HTMLElement = document.getElementById('side_nav');
    if (sidenavEl == null) return;

    const headerEl: HTMLElement = document.querySelector('header.siteHeader');
    if (headerEl) {
        const navEl: HTMLElement = headerEl.querySelector('nav.navbar');
        if (navEl) {
            const calcHeight = navEl.getBoundingClientRect().height + 16;
            sidenavEl.style.paddingTop = calcHeight + 'px';

            var z_index = null;
            if (sidenavEl.style.zIndex) {
                z_index = sidenavEl.style.zIndex;
            } else {
                var sidenavStyle: CSSStyleDeclaration = getComputedStyle(sidenavEl);
                if (sidenavStyle.zIndex) {
                    z_index = sidenavStyle.zIndex;
                }
            }
            if (z_index) {
                navEl.style.zIndex = (Number.parseInt(z_index) + 1).toString();
            }
        }
    }

    var slimCollapsed = false;

    const attrValue = sidenavEl.getAttribute('data-mdb-slim-collapsed');
    if (attrValue && attrValue == 'true') {
        slimCollapsed = true;
    }

    sidenavInstance = new Sidenav(sidenavEl);
    sidenavInstance.update({
        hidden: false,
        slim: true,
        slimCollapsed: slimCollapsed,
        slimWidth: 70,
        transitionDuration: 0,
        width: 200,
    });
    sidenavInstance.show();

    const togglerEl: HTMLElement = document.getElementById('slim-toggler');
    if (togglerEl == null) return;

    togglerEl.addEventListener('click', () => {
        sidenavInstance.toggleSlim();
    });
}

function resizeWindow() {
    // Check necessary for Android devices
    if (window.innerWidth === innerWidth) {
        return;
    }
    innerWidth = window.innerWidth;

    if (window.innerWidth < 1024) {
        if (!isSlim) {
            sidenavInstance.toggleSlim();
            isSlim = true;
        }
    } else {
        if (isSlim) {
            sidenavInstance.toggleSlim();
            isSlim = false;
        }
    }
}

initSideNav();

if (sidenavInstance) {
    resizeWindow();
    window.addEventListener('resize', resizeWindow);
}
